// extracted by mini-css-extract-plugin
export var modalFooter = "_t5-0";